"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var WatchPage_1 = __importDefault(require("./WatchPage"));
var VideoErrorState_1 = __importDefault(require("../common/VideoErrorState"));
var mountIsland_1 = require("../../mountIsland");
var Lang_js_1 = require("../../Lang.js");
var routes = [
    {
        path: "/app/twi/watch",
        element: react_1.default.createElement(WatchPage_1.default, { domVideoLoaded: false }),
        errorElement: react_1.default.createElement(VideoErrorState_1.default, { message: (0, Lang_js_1.__)('Unable to load video') }),
    },
];
var router = (0, react_router_dom_1.createBrowserRouter)(routes);
var videoContainer = document.getElementById('video-show');
if (videoContainer) {
    (0, mountIsland_1.mountIsland)(videoContainer, react_1.default.createElement("div", { className: "watch-app-wrapper" },
        react_1.default.createElement(react_router_dom_1.RouterProvider, { router: router })));
}
